import { render, staticRenderFns } from "./Objetivos.vue?vue&type=template&id=1b796864&scoped=true&"
import script from "./Objetivos.vue?vue&type=script&lang=js&"
export * from "./Objetivos.vue?vue&type=script&lang=js&"
import style0 from "./Objetivos.vue?vue&type=style&index=0&id=1b796864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b796864",
  null
  
)

export default component.exports